import { Policyholder } from './types'

export const isPolicyholderWithAccount = (
  policyholder: Policyholder | undefined,
): boolean => Boolean(policyholder?.accountRegistered)
